/* eslint-disable no-debugger */
/* eslint-disable no-lonely-if */
/* eslint-disable no-sequences */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-empty */

import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
import {
  Grid,
  Button as MuiButton,
} from "@material-ui/core";
import {
  useHistory,
  useLocation,
  useParams
} from "react-router-dom";
import Radio from "@mui/material/Radio";


import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import styles from "./AccessControlForm.module.css";
import {
  CustomFormGroup,
  ValidatingTextField,CustomDatePickerFinancial
} from "../FormComponents";
import {
  MESSAGE_TYPE,
  RESOURCE_TYPE,
} from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import AdditionalAccess from "./AdditionalAccess";
import BookingStatus from "../BookingStatus/BookingStatus"; 
import {
  fetchChassis,
  getInvoice,
} from "../../redux/actions/productsActions";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import MultiSelects from "../FormComponents/MultiSelects";
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../CvLoader/Cvloader";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";
import apiService from "../../apis/apiService";


const initialState = {
  pers_no: "",
  BU: { label: "", value: "" },
  SUB_BU: "",
  PLATFORM: "",
  FAMILY: "",
  project_def: "",
  stmNo: "",
  chassisNo: null,
  toDate: null,
  fromDate: null,
  bodyBuilder: null,
  checkFlag: false,
  checkBox: false,
  checkTable: false,
  searchBox: "",
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

function AccessControlForm({
  redirectToProcessPage,
  product,
  counter,
  baseUrl,
  // auth,
}) {
  const { requestType, activeId } = useParams();
 
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0,
  });
  // const[Loadings,setLoadings]=useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showPopup } = usePopupManager();
  const history = useHistory();
  const dispatchNew= useDispatch();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [proDetails, setProDetails] = useState("");
  const [eDetails, setEDetails] = useState("");
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [ExProjectDropdownList, setExProjectDropdownList] = useState([]);
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [projectDetails, setProjectDetails] = useState([]);
  const [process, setProcess] = useState("");
  const[maxDate,setMaxDate]=useState(null);
  const[startDateDB, setStartDateDB]=useState(null)
  const[endDateDb,setEndDateDb]=useState(null);
  const[creationDate,setCreationDate]=useState(null);
  const searchByTicket = useDebounceSearch(eDetails,500)  
  const auth = useSelector((state) => state.auth);
    let {
    userName,
    personNumber,
    companyCode,
    costCenter,
    userRole,
    sessionId,
    apiSendData
  } = auth;

  const [disableTicketNumber, setDisableTicketNumber] = useState(false);
  const [apiPayloadData, setAPIPaylodData] = useState(apiSendData);

  useEffect(() => {
    if (requestType) {
      const type = requestType.split("-").shift();
      if (type === "BS") {
        setProcess("Status");
      } else if (type === "PL") {
        setProcess("Project Linkage");
      }
    }
  }, [requestType, activeId]);

  useEffect(() => {
    if (!userRole.includes("SA")) {
      setDisableTicketNumber(true);
      setEDetails(personNumber)

    }
  }, [eDetails]);

  const [finalSaveData, setFinalSaveData] = useState([]);
  const [ProjectDropdownList, setProjectDropdownList] = useState([]);
  const [proDefDetails, setProDefDetails] = useState([]);
  const [changeFlag, setChangeFlag] = useState("");
  const [filterData, setFilterData] = useState([]);


  const request_type = useParams();
  const { parameter } = useParams();
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (parameter === "APL") {
      setProcess("Project Linkage");
      setProDetails("Additional Project Linkage");
      setChangeFlag('NEW')
    }
    else if (parameter === "AA") {
      setProcess("Additional Access");
    }
    else if (parameter === "BS") {
      setProcess("Status");
    }
  }, [parameter]);

  useEffect(() => {
    if (request_type.requestType != undefined) {
      setDisable(true);
      if (
        request_type.requestType === "AA-NA-SUP" ||
        request_type.requestType === "AA-RTA-SUP" ||
        request_type.requestType === "AA-NA-DS" ||
        request_type.requestType === "AA-RTA-DS"
      ) {
        setProcess("Additional Access");
      }
    }
  }, [request_type, process]);

  const [LinkageAccess, setLinkageAccess] = useState(false);
  const [additionalAccess, setAdditionalAccess] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(false);

  const [tableData, setTableData] = useState([]);

  const [empDetails, setEmpDetails] = useState([]);
  const [bcNo,setBcNo] = useState('')
  const [buDropdownList, setBuDropdownList] = useState([]);
  const [subBudropdownList, setSubBuDropdownList] = useState([]);
  const [platformdropdownList, setPlatformDropdownList] = useState([]);
  const [familydropdownList, setFamilyDropdownList] = useState([]);
  const [myState, setState] = React.useState({
    // poNo: "",
    pers_no: "",
    BU: { label: "", value: "" },
    SUB_BU: "",
    PLATFORM: "",
    FAMILY: "",
    project_def: "",
    user_remark: "",
    ticket_no: "",
    flag: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    hrs: "",
    spoc_ticket_no: "",
    spoc_remark: "",
    bodyBuilder: null,
    checkFlag: false,
    checkBox: false,
    checkTable: false,
    searchBox: "",
  });
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedRow, setSelectedRow] = useState([]);
  const [existingData, setExistingData] = useState([]);
  const [modifiedData, setModifiedData] = useState([]);
  const [checkTableData, setCheckTableData] = useState([]);
  const [approveFlag, setApproveFlag] = useState("");
  const [finalData, setFinalData] = useState([]);
  const [loadingTruck, setLoadingTruck] = React.useState(false);
 
  const isValidInput = (input) => {
    const validCharacters =/^[a-zA-Z0-9.,/&?' -]+$/;
    return validCharacters.test(input);
  };

  const handleUserData = (e) => {
    const { name, value } = e.target;
    if (name == "user_remark") {
      setState((prevData) => ({ ...prevData, user_remark: value }));
    } else if (name == "pers_no") {
      setState((prevData) => ({ ...prevData, pers_no: sanitizeNumeric(value) }));
    } else if (name == "spoc_remark") {
      setState((prevData) => ({ ...prevData, spoc_remark: value }));
    }
  };
  const searchClick = async() => {
    setLoadingTruck(true)
    setState((prevState) => ({ ...prevState, checkTable: true }));
    const commaSeparatedValues = proDefDetails
      .map((item) => item.value.split("-")[0])
      .join(",");
    let apiFormatedData = {
      bu: "",
      sub_bu: "",
      family: "",
      platform: "",
      project_def: commaSeparatedValues,
      bc_no: empDetails.bc_number || bcNo,
      pers_num: eDetails,
      flag: changeFlag,
    };
    try {
      const response = await apiService.projectLinkageSearch(apiFormatedData,dispatchNew)
      if (response) {
        if(response.msg === "Success"){
          setLoadingTruck(false)
          // Changes Start for CR-260203-0028
        const filteredUpdatedData = response.data.filter((item)=> item.request_pers ==='SA');
        const unique = Array.from(new Map(filteredUpdatedData.map(item=>[item.project_def,item])).values())  
              if(filteredUpdatedData.length){
                showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: filteredUpdatedData.length > 0 && (
                    <>
                      <p style={{margin:'0px'}}>
                        Linkage SPOC is not available for this Projects                           
                      </p>
                      <p style={{margin:'0px'}}>
                      {(unique.map(item => item.project_def).join(", "))}
                      </p>
                      <p style={{margin:'0px'}}>Please contact the Chief Engineer’s Office</p>
                    </>
                  )
                });
              }
            //  Changes END for CR-260203-0028
        const finalList = []
        const projectDefMap = new Map();
        response.data.forEach((row, index) => {
          const existingEntry = projectDefMap.get(row.project_def);

          if (existingEntry) {
            // If an entry with the same project_def already exists, update spoc_name
            existingEntry.spoc_name += `, ${row.spoc_name}`;
            existingEntry.spoc_ticket_no += `, ${row.spoc_ticket_no}`;
          } else {
            // If no entry with the same project_def exists, add a new entry to finalList
            projectDefMap.set(row.project_def, {
              id: index,
              ...row,
              effective_date: moment().format('YYYY-MM-DD'),
               end_date: moment().add(90, 'days').format('YYYY-MM-DD'),
              max_date: getCurrentFiscalYearEndDate(moment().format('YYYY-MM-DD'))
            });
          }              
        })
       setExistingData([...projectDefMap.values()]);
      }
      if(response.msg === "Fail" ){
        setLoadingTruck(false)
    }
    }}catch (error) {
      setLoadingTruck(false)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Oops! Something went wrong. Please try again later",

        });
    }
    finally{
      setLoadingTruck(false)
    }          
  }



  const getEmployeeDetails = async() => {
    setLoadingTruck(true);
    let apiFormatedData = {
      pers_no: sanitizeNumeric(eDetails),
      co_code: sanitizeCoCodeNumeric(companyCode)
    }; 
    try {
      const response = await apiService.projectLinkage(apiFormatedData,dispatchNew)
      dispatchNew(setLogin({...auth, recentStatus: response.status}))
      if (response?.msg === 'Success') {
        setLoadingTruck(false);
        if (response.msg === 'Either User is non-bookable or belongs to non-bookable cost center' && !userRole.includes('SA')) {
          history.push('/home')
        }
        
        if (response.data["EmpdetailsList"].length === 0) {
       

          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: response.msg,
          });
          setEDetails([]);
        } else {
          if(response.msg === "Success" ){
            setLoadingTruck(false)
        
          setEmpDetails(response.data["EmpdetailsList"][0]);
          setBcNo(response.data["EmpdetailsList"][0]?.bc_number)
          const Projectdropdown = [];
          response.data.bu_Dropdown.map((row) => {
           
            Projectdropdown.push({
              label: `${row.project_def}-${row.project_desc}`,
              value: `${row.project_def}-${row.project_desc}`,
            });
          });

          setProjectDropdownList(Projectdropdown);
          
          const BUdropdown = [];
          response.data.bu_Dropdown.map((row) => {
            BUdropdown.push({ label: row.code_desc, value: row.code_desc });
          });
          setBuDropdownList(BUdropdown);
       
          const SUB_BUdropdown = [];
          response.data.bu_Dropdown.map((row) => {
            SUB_BUdropdown.push({ label: row.sub_bu, value: row.sub_bu });
          });
          setSubBuDropdownList(SUB_BUdropdown);
          const Platformdropdown = [];
          response.data.bu_Dropdown.map((row) => {
            Platformdropdown.push({
              label: row.platform,
              value: row.platform,
            });
          });
          setPlatformDropdownList(Platformdropdown);
          const Familydropdown = [];
          response.data.bu_Dropdown.map((row) => {
            Familydropdown.push({ label: row.family, value: row.family });
          });
          setFamilyDropdownList(Familydropdown);
        }  
         else if(response.msg === "Fail"){
              setLoadingTruck(false)
          }
        
      }
      }
    } catch (error) {
      setLoadingTruck(false)
    } finally{
      setLoadingTruck(false)
    }
   ;
  };

  const onChangeHandler = (event) => {
    const inputValue = event.target.value.trim();
    if (/^\d*$/.test(inputValue)) {
      setEDetails(inputValue);
    }
  };


  useEffect(() => {
    if (parameter === "APL" &&
      [6, 8].includes(searchByTicket?.length)) {
      getEmployeeDetails();
    } else {
      setEmpDetails([]);
      setProjectDropdownList([]);
      setExProjectDropdownList([]);
      setBuDropdownList([]);
      setSubBuDropdownList([]);
      setPlatformDropdownList([]);
      setFamilyDropdownList([]);
      setProDefDetails([]);
    }
  }, [searchByTicket,parameter]);

  useEffect(() => {
    const getRequestDetails = async() => {
      let apiFormatedData = {
        request_id: activeId,
      };

      try {
        const response = await apiService.AccessControlRequestDets(apiFormatedData,dispatchNew)         
          if (response["msg"] === "Success") {
        
            let currdate=response?.data?.project_details[0].creation_date
            let startDateDBVal = response?.data?.project_details[0].effective_date;
            let endDateDBVal = response?.data?.project_details[0].end_date;
            let formattedDate= moment(currdate,'DD-MM-YYYY').format('MM-DD-YYYY');
            setCreationDate(new Date(formattedDate))
            setEndDateDb(new Date(endDateDBVal));
            setStartDateDB(startDateDBVal);
            setState((prevData) => ({
              ...prevData,
              employee_details: response?.data?.employee_details[0],
              pl_hours: response?.data?.project_details[0]["pl_hours"],
              user_remark:
              response?.data?.project_details[0]["user_remark"],
              effective_date:
              response?.data?.project_details[0]["effective_date"],
              end_date: response?.data?.project_details[0]["end_date"],
              max_date: response?.data?.project_details[0]["effective_date"],
              SPOCDetails:
              response?.data?.project_details[0]["spoc_ticket-no"],
            }));
            setEmpDetails(response?.data?.employee_details[0]);
            setProDefDetails(response?.data?.project_details[0]);
            if (response?.data?.project_details[0].request_type == "NEW") {
              setProDetails("Additional Project Linkage");
              setState((prevState) => ({
                ...prevState,
                checkFlag: true,
                checkTable: true,
              }));
            } else if (
              response?.data?.project_details[0].request_type == "EXTENDED"
            ) {
              setProDetails("Extend Existing Project Linkage");
              setState((prevState) => ({
                ...prevState,
                checkFlag: true,
                checkTable: true,
              }));
            }
          }

          if (response?.data != "User Logged In On another Screen") {
          const finalyList = [];
          const projectDefMap = new Map();
          response?.data?.project_details.forEach((row, index) => {
            const existingEntry = projectDefMap.get(row.project_def);

            if (existingEntry) {
              // If an entry with the same project_def already exists, update spoc_name
              existingEntry.spoc_name += `, ${row.spoc_name}`;
              existingEntry.spoc_ticket_no += `, ${row.spoc_ticket_no}`;
            } else {
              // If no entry with the same project_def exists, add a new entry to finalList
              projectDefMap.set(row.project_def, {
                id: index,
                ...row,
                // max_date: row.effective_date,
                max_date: getCurrentFiscalYearEndDate(row.effective_date)
              });
            }
          });
          setExistingData([...projectDefMap.values()]);
          setState((prevState) => ({ ...prevState, ticket_no: "" }));
        }
      } catch (error) {
        console.info(error);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Oops! Something went wrong. Please try again later",
            });
      }
     
    };
    if (activeId && requestType === "PL") {
      getRequestDetails();
    }
  }, [requestType, activeId]);

  const handleApproveReject = async(flag) => {
      const filtered = Object.assign({}, ...
        Object.entries(checkedItems).filter(([k,v]) => v===true).map(([k,v]) => ({[k]:v}))

      );
      const indexList = activeId||  changeFlag=="EXTENDED" ? Object.keys(filtered) : [...Array(existingData?.length).keys()]
            const filteredData = existingData.filter((obj, index) => indexList.includes(index.toString()) || indexList.includes(index) );
      let errorParamsList = []
      filteredData.map((obj, index) =>{
        // console.log(obj, 'obj')
        let errorParams = {}
        const yesterday = moment().clone().subtract(1, 'days');
        if(moment(obj.effective_date).startOf('day').isBefore(moment().startOf('day'))){
          if(errorParams?.date === undefined){
            errorParams["date"] = ` Start Date `
          }else{
            errorParams["date"] = `${errorParams?.date}, Start Date`
          }
        }
        if(moment(obj.end_date).startOf('day').isBefore(moment().startOf('day')) || moment(obj.end_date).startOf('day').isBefore(moment(obj.effective_date).startOf('day'))){
          if(errorParams?.date === undefined){
            errorParams["date"] = ` End Date `
          }else{
            errorParams["date"] = `${errorParams?.date}, End Date `
          }
        }
        if (Object.keys(errorParams).length > 0){
          errorParams["project"] = obj.project_def
          errorParamsList.push(errorParams)
        }
      })
      // console.log(errorParamsList)
      if(errorParamsList.length>0){
        let msg = ""
        errorParamsList.map((obj) =>{
          msg = msg + " For " + obj["project"] +" - "
          Object.keys(obj).map((key) =>{
            if(key == "date"){
              msg += `Please select future dates ${obj?.date} `
            }
          })
        }
        )
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: msg,
        })
        errorParamsList = []
        msg = ""
      }
     
      else{
        let apiFormatedData = existingData.map((item) => ({
          request_id: activeId,
          spoc_flag: flag,
          user_id: auth.personNumber,
          linkage_spoc_remark: myState.spoc_remark,
          effective_date: item.effective_date,
          end_date: item.end_date,
          pl_hours: item.pl_hours,
          proj_def: item.project_def,
          project_desc: item.project_desc,
          user_remark: item.user_remark,
          request_type: item.request_type,
        }))

        if(apiFormatedData?.length > 0){
          const {effective_date,end_date}=apiFormatedData[0]
          let momentEffecttivedate=moment(effective_date,'YYYY-MM-DD').format('DD-MM-YYYY');
          let momentend_date=moment(end_date,'YYYY-MM-DD').format('DD-MM-YYYY');
           let apiFalse=true
          const isSameOrAfter = moment(momentEffecttivedate, 'DD-MM-YYYY').isAfter(moment(momentend_date, 'DD-MM-YYYY'));

         
           if (isSameOrAfter) {
            showPopup({
             type: MESSAGE_TYPE.INFORMATION,
             contextText: MESSAGE_TYPE.INFORMATION,
             info: "End Date Should Be Greater Than Start Date ",
           });
           apiFalse=false
           } 
           if(apiFalse){
            setLoadingTruck(true)
             try {
              const response = await apiService.ProjectLinkageApprove(apiFormatedData,dispatchNew)
              dispatchNew(setLogin({...auth, recentStatus: response.status}))
              if (response?.data) {
                setLoadingTruck(false)
                 if (response.msg=="Success") {
                  setLoadingTruck(false)
                   setState(initialState);
                   setEDetails(0);
                   let MSG = "";
                   if (flag === "A") {
                     MSG = `Request approved for : ${activeId}.`;
                     showPopup({
                       type: MESSAGE_TYPE.SUCCESS,
                       contextText: MESSAGE_TYPE.SUCCESS,
                       info: MSG,
                     });
                   } else if (flag === "R") {
                     MSG = `Request rejected for : ${activeId}.`;
                     showPopup({
                       type: MESSAGE_TYPE.SUCCESS,
                       contextText: MESSAGE_TYPE.SUCCESS,
                       info: MSG,
                     });
                   }
                   setApproveFlag(flag);
                 }
                 else if(response.msg=="Fail"){
                  setLoadingTruck(false)
                  showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: response.data,
                  });
                 }
               }
             } catch (error) {
              setLoadingTruck(false)
                 console.info(error);
                 showPopup({
                   type: MESSAGE_TYPE.INFORMATION,
                   contextText: MESSAGE_TYPE.INFORMATION,
                   info: "Oops! Something went wrong. Please try again later",
                 });
             }finally{
              setLoadingTruck(false)
             }
             history.push("/linkage-dashboard");
             errorParamsList = []            
           }  
       }
      }

    // }

  };

  const updateFinalData = () => {
    const filteredData = modifiedData.filter(
      (item, index) => checkedItems[index] === true
    );

    setFinalData(filteredData);

  };

  useEffect(() => {
    if (checkedItems.length != 0) {
      updateFinalData();
    }
  }, [checkedItems, modifiedData]);

  useEffect(() => {
  }, [finalData]);

  useEffect(() => {
    if (proDefDetails !== undefined && proDefDetails.length === 0) {
      setExistingData('');
    }
  }, [proDefDetails]);

  const handleSelectedProjectsChange = (newSelectedProjects) => {
    const newModifiedData = newSelectedProjects.map((item) => ({
      ...item,
      effective_date: item.effective_date || "",
      end_date: item.end_date || "",
      hrs: item.hrs || item.pl_hours || "",
    }));
    setModifiedData(newModifiedData);
  };

  useEffect(() => {
        if (existingData.length > 0) {
      handleSelectedProjectsChange(existingData);
    }
  }, [existingData]);
 
  const handleStartDateChange1 = (momentDate, index) => {
    const momentFormat = momentDate['_f']
    const value = momentDate["_i"];
    const finalUpdatedData = [...modifiedData];
    if (index >= 0 && index < finalUpdatedData.length) {
      const formattedDate = momentDate.format("YYYY-MM-DD");
      finalUpdatedData[index].effective_date = formattedDate;     

      const isDateFormatYYYYMMDD = moment(formattedDate, 'YYYY-MM-DD', true).isValid();
      const isDateFormatDDMMYYYY = moment(formattedDate, 'DD-MM-YYYY', true).isValid();
      if (isDateFormatYYYYMMDD) {
        const effective_date = moment(formattedDate, "YYYY-MM-DD");
         const end_date = effective_date.clone().add(90, "days");
        const end_date1 = getCurrentFiscalYearEndDate(effective_date)
        finalUpdatedData[index].effective_date = formattedDate;
        finalUpdatedData[index].end_date = end_date;
        finalUpdatedData[index].max_date = end_date1;
      }
      else if (isDateFormatDDMMYYYY) {
        const effective_date = formattedDate;
        const end_date = getCurrentFiscalYearEndDate(effective_date)
        finalUpdatedData[index].effective_date = formattedDate;
        finalUpdatedData[index].end_date = end_date;
        finalUpdatedData[index].max_date = end_date;
      }
      const newDate = moment(maxDate, 'DD-MM-YYYY').format('MM-DD-YYYY'); 
      setModifiedData(finalUpdatedData);
      setExistingData(finalUpdatedData);
    }  
  };

  const handleStartDateChange = (momentDate, index) => {
    const momentFormat = momentDate['_f']
    const value = momentDate["_i"];
    const finalUpdatedData = [...modifiedData];
    if (index >= 0 && index < finalUpdatedData.length) {
      const formattedDate =momentDate.format("YYYY-MM-DD");
      finalUpdatedData[index].effective_date = formattedDate;     
      const effective_date = moment(formattedDate, "YYYY-MM-DD");
        const end_date = effective_date.clone().add(90, "days");
        setStartDateDB(effective_date);
        const end_date1 = getCurrentFiscalYearEndDate(effective_date)
        finalUpdatedData[index].effective_date = formattedDate;
        finalUpdatedData[index].end_date = end_date;
        finalUpdatedData[index].max_date = end_date1;
      
      setModifiedData(finalUpdatedData);
      setExistingData(finalUpdatedData);
    }
  };

   // Approval enddate

   const handleEndDateChangeApproval = (momentDate, index) => {
    const value = momentDate["_i"];
        const momentFormat = momentDate['_f']
    const formattedDate = momentDate.format("DD-MM-YYYY")
    const finalUpdatedData = [...modifiedData];
    if (index >= 0 && index < finalUpdatedData.length) {
            finalUpdatedData[index].end_date = moment(formattedDate,"DD-MM-YYYY").format("YYYY-MM-DD");                  
            setModifiedData(finalUpdatedData);
      setExistingData(finalUpdatedData);
          }
  };
  const handleEXStartDateChange = (momentDate, index) => {
    
    const momentFormat = momentDate['_f']
    const value = momentDate["_i"];
 
    const finalUpdatedData = [...filterData];
    if (index >= 0 && index < finalUpdatedData.length) {
      const formattedDate = momentDate.format("YYYY-MM-DD");
      finalUpdatedData[index].end_date = formattedDate;
      const isDateFormatYYYYMMDD = moment(formattedDate, 'YYYY-MM-DD', true).isValid();
      const isDateFormatDDMMYYYY = moment(formattedDate, 'DD-MM-YYYY', true).isValid();

        const effective_date = moment(formattedDate, "YYYY-MM-DD");
        const end_date = effective_date.clone().add(90, "days");
        const end_date1 =  getCurrentFiscalYearEndDate(effective_date);
        finalUpdatedData[index].effective_date = formattedDate;
        finalUpdatedData[index].end_date = end_date;
        finalUpdatedData[index].max_date = end_date1;
      setFilterData(finalUpdatedData);
    }
  };

  const handleEndDateChange = (momentDate, index) => {
    const value = momentDate["_i"];
    const momentFormat = momentDate['_f']
    const formattedDate = (momentFormat === "YYYY-MM-DD") ? momentDate.format("YYYY-MM-DD") : momentDate.format("DD-MM-YYYY")
    const finalUpdatedData = [...modifiedData];
    if (index >= 0 && index < finalUpdatedData.length) {
      finalUpdatedData[index].end_date = formattedDate;
      setModifiedData(finalUpdatedData);
      setExistingData(finalUpdatedData);
    }
  };

  const handleEXEndDateChange = (momentDate, index) => {
    const value = momentDate["_i"];
    const momentFormat = momentDate['_f']
    const formattedDate = (momentFormat === "YYYY-MM-DD") ? momentDate.format("YYYY-MM-DD") : momentDate.format("DD-MM-YYYY")
    const finalUpdatedData = [...filterData];
    if (index >= 0 && index < finalUpdatedData.length) {
      finalUpdatedData[index].end_date = formattedDate;
      setFilterData(finalUpdatedData);
    }
  };

  useEffect(() => {
    if ((eDetails.length === 6 || eDetails.length === 8)  && parameter=="APL") {
      handleExtendedDetails();
    }

  }, [eDetails, empDetails]);

  const handleExtendedDetails = async(e) => {
    if (e === "Extend Existing Project Linkage") {
      // debugger
      setChangeFlag("EXTENDED");
      setEDetails("");
      setEmpDetails([]);
      setCheckedItems({})
      setState((prevData) => ({ ...prevData, user_remark: "" }));
    }
    setState((prevState) => ({
      ...prevState,
      checkFlag: true,
      checkTable: true,
    }));
    const commaSeparatedValues = ExProjectDropdownList.map((item) => item.value.split("-")[0]).join(",");
    let apiFormatedData = {
      bu: "",
      sub_bu: "",
      family: "",
      platform: "",
      project_def: commaSeparatedValues,
      bc_no: empDetails.bc_number || bcNo,
      pers_num: eDetails,
      flag: changeFlag,
    };
    
    try {
      const response = await apiService.projectLinkageSearch(apiFormatedData,dispatchNew)
      if (response?.data) {         
        const finalList = [];
        const projectDefMap = new Map();
        response.data.forEach((row, index) => {
        const existingEntry = projectDefMap.get(row.project_def);
  
    if (existingEntry) {
      // If an entry with the same project_def already exists, update spoc_name
      existingEntry.spoc_name += `, ${row.spoc_name}`;
      existingEntry.spoc_no += `, ${row.spoc_no}`;
  } else {
    // If no entry with the same project_def exists, add a new entry to finalList
    projectDefMap.set(row.project_def, {
      id: index,
      ...row,
    });
  }
});
setExistingData([...projectDefMap.values()]);

const EXProjectdropdown = [];
const uniqueProjects = new Set();
response.data.forEach((row) => {
  // Check if the project_def has been encountered before
  if (!uniqueProjects.has(row.project_def)) {
    // If it hasn't, add it to the dropdown and mark it as seen
    EXProjectdropdown.push({
      label: `${row.project_def}-${row.project_desc}`,
      value: `${row.project_def}`,
    });
    uniqueProjects.add(row.project_def);
  }
});
setExProjectDropdownList(EXProjectdropdown);
} else {
    showPopup({
     type: MESSAGE_TYPE.INFORMATION,
     contextText: MESSAGE_TYPE.INFORMATION,
     info: "No Project Linkage Available",
    });
}
    } catch (error) {
      console.error(error)
    }
  };

  const handleCancelClick = () => {
    setState(initialState);
    setEDetails([]);
  };
  
  const handleSubmit = async() => { 
    const filtered = Object.assign({}, ...
      Object.entries(checkedItems).filter(([k, v]) => v === true).map(([k, v]) => ({ [k]: v }))

    );
    const indexList = activeId ? Object.keys(filtered) : [...Array(existingData?.length).keys()]
        const filteredData = existingData.filter((obj, index) => indexList.includes(index.toString()) || indexList.includes(index));

    let errorParamsList = []
    filteredData.map((obj, index) => {
      let errorParams = {}
      const yesterday = moment().clone().subtract(1, 'days');
      if (changeFlag == "NEW") {
        const currentDate = new Date();
        const currentDateNew = moment(currentDate).format("DD-MM-YYYY");
        const startDateObject = moment(new Date(obj.effective_date), 'DD-MM-YYYY')
        const endDateObject = moment(new Date(obj.end_date), 'DD-MM-YYYY')
        const [day, month, year] = currentDateNew.split("-");
        const startDay = startDateObject.date();
        const startMonth = startDateObject.month() + 1;
        const startYear = startDateObject.year();
        const endDay = endDateObject.date();
        const endMonth = endDateObject.month() + 1;
        const endYear = endDateObject.year();
        var currentDt = new Date(year, month, day);
        var startDate = new Date(startYear, startMonth, startDay);
        var endDate = new Date(endYear, endMonth, endDay);
        if (startDate >= currentDt) {
        }
        else {
          if (errorParams?.date === undefined) {
            errorParams["date"] = ` Start Date `
          } else {
            errorParams["date"] = `${errorParams?.date}, Start Date`
          }
        }
        if (startDate <= endDate) {
        }
        else {
          if (errorParams?.date === undefined) {
            errorParams["date"] = ` End Date `
          } else {
            errorParams["date"] = `${errorParams?.date}, End Date`
          }
        }
      }
      else if (activeId || changeFlag == "EXTENDED") {
        if (moment(obj.effective_date).startOf('day').isBefore(moment().startOf('day'))) {
          if (errorParams?.date === undefined) {
            errorParams["date"] = ` Start Date `
          } else {
            errorParams["date"] = `${errorParams?.date}, Start Date`
          }
        }
        if (moment(obj.end_date).startOf('day').isBefore(moment().startOf('day')) || moment(obj.end_date).startOf('day').isBefore(moment(obj.effective_date).startOf('day'))) {
          if (errorParams?.date === undefined) {
            errorParams["date"] = ` End Date `
          } else {
            errorParams["date"] = `${errorParams?.date}, End Date `
          }
        }
      }
      if (Object.keys(errorParams).length > 0) {
        errorParams["project"] = obj.project_def
        errorParamsList.push(errorParams)
      }
    })
    if (errorParamsList.length > 0) {
      let msg = ""
      errorParamsList.map((obj) => {
        msg = msg + " For " + obj["project"] + " - "
        Object.keys(obj).map((key) => {
                      if (key == "date") {
            msg += `Please select future dates ${obj?.date} `
          }
         
        })
      }
      )
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: msg,
      })
      errorParamsList = []
      msg = ""
    }
    
    else {
// ************************** Changes Start for CR-260203-0028 *************************
      setLoadingTruck(true)
       const filteredSpoc = existingData.filter(item=>item.request_pers !=='SA')
      if (filteredSpoc.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info:"No valid SPOC data available. Cannot proceed."
        })
        setLoadingTruck(false)
        return;
      }
      let apiFormatedData = filteredSpoc.map((item) => ({
// *************************** Changes END for CR-260203-0028 ******************************************
        "pers_no": sanitizeNumeric(eDetails),
        "cost_center": empDetails.bc_number,
        "user_id": personNumber,
        "request_type": "PL",
        "user_remark": myState.user_remark ? myState.user_remark : "",
        "start_date": /^\d{4}-\d{2}-\d{2}$/.test(item.effective_date)
          ? item.effective_date
          : moment(item.effective_date, "DD-MM-YYYY").format("YYYY-MM-DD"),
        "end_date": /^\d{4}-\d{2}-\d{2}$/.test(item.end_date)
          ? item.end_date
          : moment(item.end_date, "DD-MM-YYYY").format("YYYY-MM-DD"),
        "pl_hours": item.pl_hours === undefined || item.pl_hours == null ? "0" : String(item.pl_hours),
        "pl_project_def": item.project_def,
        "spoc_pers_no": sanitizeNumeric(item.spoc_ticket_no) || sanitizeNumeric(item.spoc_no),
        "flag":changeFlag
      }));  
      try {
        const response = await apiService.ProjectLinkageSave(apiFormatedData,dispatchNew)  
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        setFinalSaveData(response?.data)
        const apiPayloadData = {
          user_id: personNumber,
          req_type: "created",
          request_status: null,
          start_date: "",
          end_date: "",
        };

        dispatchNew(setLogin({...auth, apiSendData: apiPayloadData}))

        const values_11 = []
        let duplicate_msg = ""
        let isDuplicates = false
        if (Array.isArray(response)) {        
        response?.map((item) => {
          if(item.vsuccess === 'T'){
            if (item.request_id_param !== ""){
            values_11.push(item.returnmsg + "-" + item.request_id_param)
            }else if(item.request_id_param === ""){
              if (isDuplicates === false) {
                duplicate_msg = "Project linkage request already in progress for " + item.returnmsg
                isDuplicates = true
              }else {
                duplicate_msg += ", " + item.returnmsg
              }

            }
          }else if (item.vsuccess === "F") {
            duplicate_msg = item.returnmsg;
          }
        })
      }
        let final_msg = ""
        if (duplicate_msg !== ""){
          if (values_11.length > 0){
            final_msg = duplicate_msg +  " and Request ID generated for project linkage"
          }else{
            final_msg = duplicate_msg

          }
        }
        else{
          final_msg = "Request ID generated for project linkage"
        }

        if (response.msg === "Fail"){
          setLoadingTruck(false)

          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Oops! Something went wrong. Please try again later",
          });
          setTableData([]);
        }
        else {
          setLoadingTruck(false)
        
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info:  final_msg,
            dataTable:values_11
          });
          history.push("/linkage-dashboard");
        }

      } catch(error) {
        setLoadingTruck(false)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: error?.response?.data?.msg || "Oops! Something went wrong. Please try again later",
        });
      }
      errorParamsList = []
    }
  };



  const handleEXSubmit = async() => {

    const filtered = Object.assign({}, ...
      Object.entries(checkedItems).filter(([k, v]) => v === true).map(([k, v]) => ({ [k]: v }))

    );
    const indexList = activeId ? Object.keys(filtered) : [...Array(existingData?.length).keys()]
    const updatedData = filterData.filter((obj, index) => indexList.includes(index.toString()) || indexList.includes(index));
    let errorParamsList = []
    updatedData.map((obj, index) => {
      let errorParams = {}
      const yesterday = moment().clone().subtract(1, 'days');
      if (changeFlag == "EXTENDED") {
        const currentDate = new Date();
        const currentDateNew = moment(currentDate).format("DD-MM-YYYY");
        const startDateObject1 = obj.effective_date
        const endDateObject1 = obj.end_date
        const startDateObject = new Date(startDateObject1);
        const endDateObject = new Date(endDateObject1);
        const [day, month, year] = currentDateNew.split("-");
        const startDay = startDateObject.getDate();
        const startMonth = startDateObject.getMonth() + 1;
        const startYear = startDateObject.getFullYear();
        const endDay = endDateObject.getDate();
        const endMonth = endDateObject.getMonth() + 1;
        const endYear = endDateObject.getFullYear();

        var currentDt = new Date(year, month, day);
        var startDate = new Date(startYear, startMonth, startDay);
        var endDate = new Date(endYear, endMonth, endDay);
        if (startDate >= currentDt) {
        }
        else {
          if (errorParams?.date === undefined) {
            errorParams["date"] = ` Start Date `
          } else {
            errorParams["date"] = `${errorParams?.date}, Start Date`
          }
        }

        if (startDate <= endDate) {
        }
        else {
          if (errorParams?.date === undefined) {
            errorParams["date"] = ` End Date `
          }
          else {
            errorParams["date"] = `${errorParams?.date}, End Date`
          }
        }
      }
     
      if (Object.keys(errorParams).length > 0) {
        errorParams["project"] = obj.project_def
        errorParamsList.push(errorParams)
      }
    })
    if (errorParamsList.length > 0) {
      let msg = ""
      errorParamsList.map((obj) => {
        msg = msg + " For " + obj["project"] + " - "
        Object.keys(obj).map((key) => {
          if (key == "date") {
            msg += `Please select future dates ${obj?.date} `
          }
        })
      }
      )
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: msg,
      })
      errorParamsList = []
      msg = ""
    }
    
    else {
// ************************* Changes Start for CR-260203-0028 ***********************************      
      const filteredSpoc = existingData.filter(
        item => item.request_pers !== "SA"
      );
      if (filteredSpoc.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info:"No valid SPOC data available. Cannot proceed."
        })
        setLoadingTruck(false)
        return;
      }
      let apiFormatedData = filteredSpoc.map((item) => ({
// *************************** Changes END for CR-260203-0028 ********************************
        "pers_no": sanitizeNumeric(eDetails),
        "cost_center": empDetails.bc_number,
        "user_id": personNumber,
        "request_type": "PL",
        "user_remark": myState.user_remark ? myState.user_remark : "",
        "start_date": /^\d{4}-\d{2}-\d{2}$/.test(item.effective_date)
          ? item.effective_date
          : moment(item.effective_date, "DD-MM-YYYY").format("YYYY-MM-DD"),
        "end_date": /^\d{4}-\d{2}-\d{2}$/.test(item.end_date)
          ? item.end_date
          : moment(item.end_date, "DD-MM-YYYY").format("YYYY-MM-DD"),
        "pl_hours": item.hours === undefined || item.hours == null ? "0" : String(item.hours),
        "pl_project_def": item.project_def,
        "spoc_pers_no": sanitizeNumeric(item.spoc_ticket_no) || sanitizeNumeric(item.spoc_no),
        "flag":changeFlag
      }));

      try {
        const response = await apiService.ProjectLinkageSave(apiFormatedData,dispatchNew)
        
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        setFinalSaveData(response.data)
        const apiPayloadData = {
          user_id: personNumber,
          req_type: "created",
          request_status: null,
          start_date: "",
          end_date: "",
        };

        dispatchNew(setLogin({...auth, apiSendData: apiPayloadData}))
        
        const values_11 = []
        let duplicate_msg = ""
        let isDuplicates = false

        response?.map((item) => {
          if(item.vsuccess === 'T'){
            if (item.request_id_param !== ""){
            values_11.push(item.returnmsg + "-" + item.request_id_param)
            }else if(item.request_id_param === ""){
              if (isDuplicates === false) {
                duplicate_msg = "Project linkage request already in progress for " + item.returnmsg
                isDuplicates = true
              }else {
                duplicate_msg += ", " + item.returnmsg
              }

            }
          }
        })
        let final_msg = ""
        if (duplicate_msg !== ""){
          if (values_11.length > 0){
            final_msg = duplicate_msg +  " and Request ID generated for project linkage"
          }else{
            final_msg = duplicate_msg

          }
        }
        else{
          final_msg = "Request ID generated for project linkage"
        }
        if (response.msg == "Fail") {
          setLoadingTruck(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records",
          });
          setTableData([]);
        }
        else {
          setLoadingTruck(false)
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info:  final_msg,
            dataTable:values_11
          });
          history.push("/linkage-dashboard");
        }
      } catch(error) {
        setLoadingTruck(false)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: error?.response?.data?.msg || "Oops! Something went wrong. Please try again later",
        });
      }finally{
        setLoadingTruck(false)
      }    
      errorParamsList = []
    }


  };

  const handleViewProDetails = (e) => {
    setViewDisplay(true);
    setEDetails("")
    setEmpDetails([])
    setIsDelete(false);
    setCheckedItems({})
    setState(initialState)
    setState((prevState) => ({ ...prevState, checkFlag: true }));
    if (e === "Additional Project Linkage") {
      setChangeFlag("NEW");
    }
  };
  const handleProjectSelection = (selectedOption) => {
        const filteredData = existingData.filter(dataItem => {
      return selectedOption.some(filterItem => filterItem.value === dataItem.project_def);
    });

    // Update effective_date and end_date in filteredData using moment
    const updatedFilteredData = filteredData.map(item => {
            const startDate = moment(item.end_date);
      const endDate = moment(startDate).add(1, 'month');
      let newEndDate= getCurrentFiscalYearEndDate(moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'))
      let newEndDate1 = startDate.clone().add(90, 'days').format('YYYY-MM-DD');
      return {
        ...item,
        effective_date: startDate.format('YYYY-MM-DD'),
        end_date: newEndDate1,
        min_date: startDate.format('YYYY-MM-DD'),
        max_date: newEndDate,
      };
    }); 

    setFilterData(updatedFilteredData);
  }

  const onLeave = () => {
    setHover({ isHover: false, name: null });
  };

  const BG_COLOR = "#fffef8";
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } =
    backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });

  const renderStatic = () => (
    <div
      className={styles.formGroup}
      style={{ backgroundColor: processInfoBg }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >

    </div>
  );

  const formatSpocDetails = (item) => {
    const spocDetailsArray = [];

    const ticketNos = (item.spoc_ticket_no || '').split(', ');
    const spocNames = (item.spoc_name || '').split(', ');

    for (let i = 0; i < ticketNos.length; i+=1) {
      const spocDetails = `${ticketNos[i]} - ${spocNames[i]}`;
      spocDetailsArray.push(spocDetails);
    }

    return spocDetailsArray.join(', ');
  };

  const formatSpocDetails1 = (item) => {
    const spocDetailsArray = [];

    const ticketNos = (item.spoc_no || '').split(', ');
    const spocNames = (item.spoc_name || '').split(', ');

    for (let i = 0; i < ticketNos.length; i+=1) {
      const spocDetails = `${ticketNos[i]} - ${spocNames[i]}`;
      spocDetailsArray.push(spocDetails);
    }

    return spocDetailsArray.join(', ');
  };


const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

function getCurrentFiscalYearEndDate(data) {
  if(data){
    var startYear = "";
    var endYear = "";
    var currentDate = moment(data, "DD-MM-YYYY");
    var month = Number(currentDate.format("MM"));
    var date = Number(currentDate.format("DD"));
    var year = Number(currentDate.format("YYYY"));
  
    // console.log(month,date,year,"2926")
  
    if (month <= 3) {
     
        startYear = year - 1;
        endYear = year;
    } else {
        startYear = year;
        endYear = year + 1;
    }

    let endDate = moment(data).add(1, 'years').format('YYYY-MM-DD');
    let getmaxDate = moment(data).add(1, 'years').format('YYYY-MM-DD');

    setMaxDate(getmaxDate);

    return endDate;

  // })
}

}

useEffect(()=>{
      getCurrentFiscalYearApprover(creationDate)
},[creationDate])

function getCurrentFiscalYearApprover(data) {
  if(data){
    var startYear = "";
    var endYear = "";
   
    var dateStr = moment(data, "DD-MM-YYYY");
    let endStr=data.end_date
    var currentDate = new Date(dateStr);
     
     let endDate = addDays(currentDate, 365);
     let getmaxDate = addDays(currentDate, 365);

     return endDate;
}

}

  const renderDetails = () => (
    <div
      className={styles.formGroup}
      style={{ backgroundColor: processInfoBg }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <div className={styles.formGroup}>
        {myState.checkFlag && (
          
          <Grid
            container
            spacing={1}
          
            style={{ marginTop: "10px" }}
            columns={12}
          >
            <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
                  <label>Project Details:</label>
                </div>
              </div>
            </Grid>
            {changeFlag === "NEW" && existingData.lenght !== 0 &&(
              <>
                <Grid item md={8} lg={8} xs={10} sm={10}>
                  <div className={styles.formDiv}>
                    {/* <CustomSelect */}
                    <MultiSelects
                      className={clsx(styles.select, styles.sel2)}
                      isMulti
                      isClearable
                      value={proDefDetails}
                      options={ProjectDropdownList}
                      onChange={(selectedOption) => {
                        setProDefDetails(selectedOption);
                      }}
                    
                      name="Project_def"
                   
                    />

                  </div>
                </Grid>
                <Grid item md={1} lg={1} xs={12} sm={6} >
                  <Button
                    className={clsx(
                      styles.actionButton,
                      styles.primaryActionButton
                    )}
                    variant="primary"
                    data-testid="confirm-action"
                    
                    onClick={() => searchClick()}
                  >
                    Search
                  </Button>

                </Grid>
              </>

            )}
            {changeFlag === "EXTENDED" && existingData.lenght !== 0 && (
              <>
                <Grid item md={8} lg={8} xs={10} sm={10}>
                  <div className={styles.formDiv}>
                    <MultiSelects
                      className={clsx(styles.select, styles.sel2)}
                      isMulti
                      isMandatory
                      isClearable
                      value={proDefDetails}
                      options={ExProjectDropdownList}
                      onChange={(selectedOption) => {
                        setProDefDetails(selectedOption);
                        handleProjectSelection(selectedOption)


                      }}
                     
                      name="Project_def"
                    
                    />
                  </div>
                </Grid>
              
              </>

            )
            }

          </Grid>
        )}

      </div>
      

      <div className={styles.formGroup}>
        {myState.checkTable && existingData.length > 0 &&
          <Grid
            container
            spacing={1}
            className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >


            <Grid item md={12} lg={12} xs={12} sm={12}>
              {activeId &&
                <TableSimple
                  tableColumnData={existingData.map((item, index) => ({
                   
                    projectNo: item.project_def,
                    projectDesc: item.project_desc,
                    startDate: (
                      <CustomDatePickerFinancial
                        // onError={dateValidation}
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                        minDate={creationDate}
                        maxDate={modifiedData[index]?.max_date}
                        autoOk
                        clearable
                        inputVariant="outlined"
                      
                        value={modifiedData[index]?.effective_date || item?.effective_date}
                        onChange={(e) => handleStartDateChange(e, index)
                        }
                        
                        emptyLabel="DD-MM-YYYY"
                        
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-approval"
                        style={{ width: "100%" }}
                      />
                    ),
                    endDate: (
                      <CustomDatePickerFinancial
                        // onError={dateValidation}
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                        autoOk
                        clearable
                        inputVariant="outlined"
                       
                        value={modifiedData[index]?.end_date || item?.end_date}
                        onChange={(e) => handleEndDateChangeApproval(e, index)}                      
                        emptyLabel="DD-MM-YYYY"                      
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-approval"
                        style={{ width: "100%" }}
                        maxDate={modifiedData[index]?.max_date}
                        minDate={creationDate}
                        // maxDate={addDays(startDateDB, 366)}
                      />
                    ),
                   
                    SPOCDetails: item.request_pers === 'SA' ? '-' : formatSpocDetails(item), // Added the changes for CR-260203-0028
                   
                    RequestId: activeId || "N/A",
                  }))}
                  tableHeaderLabel={[
                    "Project No_70",
                    "Project Description_150",
                    "Start Date_80",
                    "End Date_80",
                    "SPOC Details_100",
                    // "Hours_40",
                    "Request Id_80",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              }
              {changeFlag == "NEW" && proDefDetails.length > 0 &&
                <TableSimple
                  tableColumnData={existingData.map((item, index) => ({
                    projectNo: item.project_def,
                    projectDesc: item.project_desc,
                    startDate: (
                      <CustomDatePickerFinancial
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                        autoOk
                        // disabled={!checkedItems[index]}
                        clearable
                        inputVariant="outlined"
                        value={moment(modifiedData[index]?.effective_date, 'YYYY-MM-DD') || moment(item?.effective_date, 'YYYY-MM-DD')}
                        onChange={(e) =>{handleStartDateChange1(e, index);
                          }}
                        // onClick={(e)=>(e)}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-2"
                        style={{ width: "100%" }}
                      //  maxDate={currentmaxDate}
                        minDate={new Date()}
                        maxDate={modifiedData[index]?.max_date}
                        // maxDate={maxDate}
                      />
                    ),
                    endDate: (
                      <CustomDatePickerFinancial
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                        autoOk
                        clearable
                        inputVariant="outlined"
                        value={modifiedData[index]?.end_date || moment(item?.end_date, "DD-MM-YYYY")}
                        onChange={(e) => handleEndDateChange(e, index)}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-2"
                        style={{ width: "100%" }}
                        maxDate={modifiedData[index]?.max_date}
                        minDate={new Date()}
                        // financial='true'
                      />
                    ),
                    SPOCDetails: item.request_pers === 'SA' ? '-' : formatSpocDetails(item), // Added the changes for CR-260203-0028
                  }))}
                  tableHeaderLabel={[
                  
                    "Project No_70",
                    "Project Description_170",
                    "Start Date_80",
                    "End Date_80",
                    "SPOC Details_100",
                   
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              }

              {changeFlag == "EXTENDED" && existingData.length !== 0 && proDefDetails.length !== 0 &&
               <TableSimple
                  tableColumnData={filterData.map((item, index) => ({                   
                    projectNo: item.project_def,
                    projectDesc: item.project_desc,
                    startDate: (
                      <CustomDatePickerFinancial
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                        
                        autoOk
                        clearable
                        inputVariant="outlined"
                        value={moment(filterData[index]?.effective_date) || item?.effective_date}
                        onChange={(e) => handleEXStartDateChange(e, index)}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-3"
                        style={{ width: "100%" }}
                        minDate={moment(filterData[index]?.effective_date) || item?.effective_date}
                        maxDate={filterData[index]?.max_date}
                      
                      />
                                         ),
                    endDate: (
                      <CustomDatePickerFinancial
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                       
                        autoOk
                        clearable
                        inputVariant="outlined"
                        value={filterData[index]?.end_date || item?.end_date}
                        onChange={(e) => handleEXEndDateChange(e, index)}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-3"
                        style={{ width: "100%" }}
                        minDate={new Date()}
                        maxDate={filterData[index]?.max_date}
                       
                      />
                    ),
                    SPOCDetails: item.request_pers === 'SA' ? '-' : formatSpocDetails1(item), // Added the changes for CR-260203-0028
                  }))}
                  tableHeaderLabel={[                 
                    "Project No_70",
                    "Project Description_170",
                    "Start Date_80",
                    "End Date_80",
                    "SPOC Details_100",
                   
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              }
            </Grid>
          </Grid>}
      </div>

    </div>
  );
  const renderOther = () => (
    <div
      className={styles.formGroup}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Ticket Number</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                onChange={(e) => setEDetails(e.target.value)}
                name="Ticket Number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "70%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>
      {(eDetails.length === 6 || eDetails.length === 8) ? renderOther1() : renderOther}
    </div>
  );

  const renderOther1 = () => (
    <div
      className={styles.formGroup}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={0}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                style={{
                  marginLeft: "21px",
                  marginRight: "11px",
                  alignItems: "center",
                  float: "center",
                }}
                value={proDetails}
                onChange={(e) => setProDetails(e.target.value)}
                defaultValue=""
                onClick={(e) => handleViewProDetails(e.target.value)}
                className={styles.radiobtn}
              >

                <FormControlLabel
                  value="Additional Project Linkage"
                  name="status"
                  control={<Radio size="small" disabled={disable} />}
                  label="Additional Project Linkage"
                  className={styles.radiobtn}
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                style={{
                  marginLeft: "21px",
                  marginRight: "11px",
                  alignItems: "center",
                  float: "center",
                }}
                options={bodyBuilderOption}
                value={proDetails}
                onChange={(e) => setProDetails(e.target.value)}
                onClick={(e) => {
                  getEmployeeDetails()
                  handleExtendedDetails(e.target.value)
                }}

                name="bodyBuilder"

              >

                <FormControlLabel
                  value="Extend Existing Project Linkage"
                  name="status"
                  control={<Radio size="small" disabled={disable} />}
                  label="Extend Existing Project Linkage"
                  className={styles.radiobtn}
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
      </Grid>
      {loadingTruck ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>): <div className={styles.formGroup}>
        {proDetails && (
          <Grid
            container
            spacing={1}
            // className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >
            <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
                  <label>Employee Details:</label>
                </div>
              </div>
            </Grid>
            <Grid item md={10} lg={10} xs={10} sm={10}>
              <div className={styles.formDiv}>
                <TableSimple
                  // tableColumnData={empDetails}
                  tableColumnData={[
                    {
                      ticket: activeId ? (
                        <div>{empDetails.employee_ticket_no}</div>
                      ) : (
                        <ValidatingTextField
                          variant="outlined"
                          size="small"
                          isDisabled={activeId || disableTicketNumber}
                          // value={empDetails.employee_ticket_no}
                          value={eDetails}
                          onChange={onChangeHandler}
                          name="Ticket Number"
                          inputProps={{
                            "data-testid": "remark-input",
                          }}
                          style={{ width: "100%" }}
                        />
                      ),
                      empl_name: empDetails?.empl_name || "",
                      bcNo: empDetails?.bc_number || "",
                      bc_name: empDetails?.bc_name || "",
                      workArea: empDetails?.workarea || "",
                    },
                  ]}
                  tableHeaderLabel={[
                    "Ticket No_70",
                    "Employee Name_140",
                    "BC No_60",
                    "BC Description_150",
                    "Work Area_230",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  // headerColor="#2C73D2"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              </div>
            </Grid>
          </Grid>
        )}
      </div>
        }
      
    </div>
  );

  const renderUserRemark = () => (
    <div
      className={styles.formGroup}
      style={{ backgroundColor: processInfoBg }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <div className={styles.formGroup}>
        <Grid
          container
          spacing={1}
          style={{
            marginTop: "10px",
          }}
          // className={styles.myGrid}
          columns={12}
        >
          <Grid item md={2} lg={2} xs={2} sm={2}>
            {/* <div className={styles.rowDiv}> */}
            <div className={clsx(styles.lableDiv2)}>
              <label>User Remark:</label>
            </div>
           
          </Grid>
          <Grid item md={10} lg={10} xs={10} sm={10}>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                isDisabled={activeId}
                value={myState.user_remark}
                
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (isValidInput(newValue) || newValue === "") {
                    handleUserData({ target: { name: "user_remark", value: newValue } });
                  }
                }}
                
                name="user_remark"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );

  const renderSPOCRemark = () => (
    <div
      className={styles.formGroup}

    >
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        // className={styles.myGrid}
        columns={12}
      >
        {activeId && (
          <>
            <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={clsx(styles.lableDiv2)}>
                <label>SPOC Remark:</label>
              </div>
            </Grid>
            <Grid item md={10} lg={10} sm={10} xs={10}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <ValidatingTextField
                    variant="outlined"
                    size="small"
                    value={myState.spoc_remark}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      if (isValidInput(newValue) || newValue === "") {
                        handleUserData({ target: { name: "spoc_remark", value: newValue } });
                      }
                    }}
                    
                    name="spoc_remark"
                    inputProps={{
                      "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </Grid>
          </>

        )}
      </Grid>


      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{
          marginTop: "10px", justifyContent: "center"
        }}
        columns={12}
      >

        <Grid item md={2} lg={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>

              {activeId ? (
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton
                  )}
                  variant="primary"
                  onClick={() => handleApproveReject("A")}
                  data-testid="confirm-action"
                >
                  Approve
                </Button>
              ) : (
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton
                  )}
                  disabled={
                    (changeFlag === 'NEW' && existingData.length === 0) ||
                    (changeFlag === 'EXTENDED' && filterData.length === 0)
                  }
                  variant="primary"
                  onClick={() => {
                    if (changeFlag == "NEW") {
                      handleSubmit();
                    }
                    else if (changeFlag == "EXTENDED") {
                      handleEXSubmit();
                    }
                  }
                  }
                  data-testid="confirm-action"
              
                >
                  Save
                </Button>

              )}
              
              {activeId ? (
                <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"
                  onClick={() => handleApproveReject("R")}
                  data-testid="confirm-action"
                 
                >
                  Reject
                </Button>
              ) : (
                <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"
                  onClick={handleCancelClick}
                  data-testid="confirm-action"
                  style={{ marginRight: "5px" }}
                >
                  Cancel
                </Button>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
    setProDefDetails();

  };
  useEffect(() => {
    // console.log("status", process)
    if (process === "Status") {
      setViewDisplay(false);
      setIsDelete(true);
      setLinkageAccess(false);
      setAdditionalAccess(false);
      setBookingStatus(true);
      setState((prevState) => ({ ...prevState, tableFlag: true }));
      setProDefDetails();
    }
  }, [process]);
  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);

  const RedirectToDashboard = () => {

    const reqtype = requestType === undefined ? parameter : requestType.split("-").shift();
    if (reqtype === "PL" || reqtype === "APL") {
      history.push("/linkage-dashboard");
      dispatch(setLogin({ ...auth, apiSendData: apiPayloadData}));
    }
    else {
      dispatch(setLogin({ ...auth, apiSendData: apiPayloadData}));
      history.push("/requestor-dashboard")
    }
  } 

  const gridFlag = activeId ? 11 : 12 ;

  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.scrollBar,
          styles.formContainer
        )}
      >

        {process === "" ? null : process === "Project Linkage" ? (
          <>
           

          <Grid container spacing={0}>
            {activeId ? <Grid item md={1} lg={1} xs={1} sm={1} style={{ marginRight: '-30px'}}> 
              <ArrowCircleLeftIcon 
                  style={{
                    fontSize:'40px', 
                    color: "#608FC9", 
                    margin: '-4px 0px 1px 10px',
                    cursor: 'pointer'
                  }} 
                  onClick={() => RedirectToDashboard()}
              />
            </Grid>
             : "" }  
            <Grid item md={gridFlag} lg={gridFlag} xs={gridFlag} sm={gridFlag}> 
              <CustomFormGroup
                header="Additional Project Linkage"
                body={renderStatic()}
              />
            </Grid>
          </Grid>

            {renderOther1()}
            {/* {eDetails&& */}
            {empDetails?.empl_name &&
              <>
                {renderDetails()}
                {renderUserRemark()}
              </>}

            {myState.checkTable && empDetails?.empl_name &&
              <>
                {renderSPOCRemark()}
              </>
            }
          </>

        ) : null}
        {process === "" ? null : process === "Additional Access" ? (
          <>
            <AdditionalAccess />
          </>
        ) : null}

        {process === "" ? null : process === "Status" ? (
          <>
            <BookingStatus />
          </>
        ) : null}
      </div>

    </>
  );
}





AccessControlForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
AccessControlForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(AccessControlForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);